import { Component, Input , AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {  Product } from '../shared/models';

@Component({
    selector: 'product-qty',
    styles: [ require('./product-qty.component.scss') ],
    template: require('./product-qty.component.pug')
})
export class ProductQtyComponent implements AfterViewInit {

    @Input() product: Product;

    fg = new FormGroup({});


    constructor() {
    }

    ngAfterViewInit() {
        this.fg.controls['qty'].valueChanges.subscribe(value => this.product.quantity = +value );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/product-qty/product-qty.component.ts